import React, { createContext, useContext, useEffect, useState } from 'react';

const LogoContext = createContext({ logoUrl: '', faviconUrl: '', title: '', loading: true });

export function LogoProvider({ children }) {
  const [logoUrl, setLogoUrl] = useState('');
  const [faviconUrl, setFaviconUrl] = useState('');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/v1/preferencias/marca')
      .then(res => res.json())
      .then(data => {
        setLogoUrl(data.logo_url || '');
        setFaviconUrl(data.icon_url || '');
        setTitle(data.page_title || '');
        setLoading(false);
      })
      .catch(() => {
        setLogoUrl('');
        setFaviconUrl('');
        setTitle('');
        setLoading(false);
      });
  }, []);

  return (
    <LogoContext.Provider value={{ logoUrl, faviconUrl, title, loading }}>
      {children}
    </LogoContext.Provider>
  );
}

export function useLogo() {
  return useContext(LogoContext);
}
